var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 12C24.125 5.57812 18.9219 0.375 12.5 0.375C6.07812 0.375 0.875 5.57812 0.875 12C0.875 17.8125 5.09375 22.6406 10.6719 23.4844V15.375H7.71875V12H10.6719V9.46875C10.6719 6.5625 12.4062 4.92188 15.0312 4.92188C16.3438 4.92188 17.6562 5.15625 17.6562 5.15625V8.01562H16.2031C14.75 8.01562 14.2812 8.90625 14.2812 9.84375V12H17.5156L17 15.375H14.2812V23.4844C19.8594 22.6406 24.125 17.8125 24.125 12Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.390c6562.svg";
export { ForwardRef as ReactComponent };